import React from 'react';
import { createUseStyles, clsx, negative } from '@pushpay/styles';
import { useMediaBreakpoint, useResponsiveProp } from '@pushpay/theming';
import { Box } from '.';
import { useMain } from './main-context';
const useStyles = createUseStyles(theme => ({
  root: {},
  fullWidth: ({
    mainSpaceH
  }) => ({
    flexGrow: 1,
    width: 'auto',
    maxWidth: '100vw',
    marginLeft: negative(theme.SPACING[mainSpaceH]),
    marginRight: negative(theme.SPACING[mainSpaceH])
  })
}));
export const FullWidthMobileBox = ({
  classes: classesProp,
  className: classNameProp,
  children,
  ...rest
}) => {
  const {
    mobileWhen,
    spaceH
  } = useMain();
  const mainSpaceH = useResponsiveProp(spaceH);
  const isMobile = useMediaBreakpoint(mobileWhen);
  const classes = useStyles(classesProp, {
    mainSpaceH
  });
  const className = clsx(classNameProp, classes.root, isMobile && classes.fullWidth);
  return /*#__PURE__*/React.createElement(Box, Object.assign({
    className: className
  }, rest), children);
};